import { memo } from 'react';

export type StepHeaderProps = {
  title: string;
  description?: string;
};

export const StepHeader = memo(({ title, description }: StepHeaderProps) => {
  return (
    <div className="flex flex-col gap-1">
      <h2 id="onboarding-dialog-title" className="font-medium text-24 text-grey-12">
        {title}
      </h2>
      {!!description && <p className="text-14 text-grey-12">{description}</p>}
    </div>
  );
});

StepHeader.displayName = 'StepHeader';
